export const WorkspaceForm = () => {

    return (
        <div className="min-h-screen flex items-center">
            <div className="w-full">
                <h2 className="text-center text-blue-400 font-bold text-2xl uppercase mb-10">Support Scope</h2>
                <div className="bg-white p-10 rounded-lg shadow md:w-3/4 mx-auto lg:w-1/2 mt-10">
                    <form>
                        <div className="mb-5">
                            <label for="name" className="block mb-2 font-bold text-gray-600">Workspace ID</label>
                            <input type="text" id="workspaceId" name="workspaceId" placeholder="Please provide your workspace ID / Crisp Website ID" className="border border-gray-300 shadow p-3 w-full rounded mb-" />
                        </div>

                        <button className="block w-full bg-blue-500 text-white font-bold p-4 rounded-lg">Submit</button>
                    </form>
                </div>
            </div>
        </div>
    )
}